<template>
  <ul
    class="pagination justify-content-end"
    v-if="shouldPaginate"
  >
    <li
      v-show="prevUrl"
      class="page-item"
    >
      <a
        href="#"
        aria-label="Previous"
        rel="prev"
        @click.prevent="page=1"
        class="page-link"
      >
        <span aria-hidden="true">&laquo;</span>
      </a>
    </li>
    <li
      v-show="prevUrl"
      class="page-item"
    >
      <a
        href="#"
        aria-label="Previous"
        rel="prev"
        @click.prevent="page--"
        class="page-link"
      >
        ‹
      </a>
    </li>
    <li
      v-for="n in this.pageRange"
      :key="n"
      class="page-item"
    >
      <a
        class="page-link"
        v-if="n=='...'"
      >...</a>
      <a
        aria-label="n"
        rel="n"
        @click="page=n"
        class="page-link"
        v-else
      >
        <span aria-hidden="true">{{n}}</span>
      </a>
    </li>
    <li
      v-show="nextUrl"
      class="page-item"
    >
      <a
        href="#"
        aria-label="Next"
        rel="next"
        @click.prevent="page++"
        class="page-link"
      >
        ›
      </a>
    </li>
    <li
      v-show="nextUrl"
      class="page-item"
    >
      <a
        href="#"
        aria-label="Last"
        rel="next"
        @click.prevent="page=dataSet.last_page"
        class="page-link"
      >
        <span aria-hidden="true">&raquo;</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['dataSet'],
  data() {
    return {
      page: this.dataSet.current_page,
      prevUrl: this.dataSet.prev_page_url,
      nextUrl: this.dataSet.next_page_url,
      pageRange: this.pagination(this.dataSet.current_page, this.dataSet.last_page),
    }
  },
  mounted(){
    console.log(this.nextUrl); 
  },
  watch: {
    page() {
      this.broadcast().updateUrl();
    }
  },
  computed: {
    shouldPaginate() {
      return !!this.prevUrl || !!this.nextUrl;
    }
  },
  methods: {
    broadcast() {
      return this.$emit('page_changed', this.page);
    },
    updateUrl() {
      history.pushState(null, null, '?page=' + this.page);
    },
    pagination(c, m) {
      var current = c,
        last = m,
        delta = 2,
        left = current - delta,
        right = current + delta + 1,
        range = [],
        rangeWithDots = [],
        l;
      for (let i = 1; i <= last; i++) {
        if (i == 1 || i == last || i >= left && i < right) {
          range.push(i);
        }
      }
      for (let i of range) {
        if (l) {
          if (i - l === 2) {
            rangeWithDots.push(l + 1);
          } else if (i - l !== 1) {
            rangeWithDots.push('...');
          }
        }
        rangeWithDots.push(i);
        l = i;
      }
      return rangeWithDots;
    }
  }
}
</script>